import { STORE_KEY } from '../constants';
import type { State } from '../reducers';

export const creditsSelector = (state: GlobalState) => state[STORE_KEY] as State | undefined;
